(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function revealAll(){
    document.querySelectorAll('.rv,.ringplay').forEach(function(e){e.classList.add('inview');});
    document.body.classList.add('loaded');
  }
  // tag reveal + ring targets
  var wraps = document.querySelectorAll('section > .wrap, .close > .wrap');
  wraps.forEach(function(w){
    Array.prototype.forEach.call(w.children, function(c,i){
      c.classList.add('rv');
      c.style.transitionDelay = (i*0.07).toFixed(2)+'s';
    });
  });
  var rings = document.querySelectorAll('.imghero-content svg, .step svg, .ringcard svg, .keeps svg');
  rings.forEach(function(s){ s.classList.add('ringplay'); });
  var heroRing = document.querySelector('.imghero-content svg');
  if(heroRing){ heroRing.classList.add('heroring'); }

  if(!('IntersectionObserver' in window)){ revealAll(); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('inview'); io.unobserve(en.target); }
    });
  }, {threshold:0.14, rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('.rv,.ringplay,.fmega').forEach(function(e){ io.observe(e); });

  // count-up
  function animCount(el){
    var target = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-dec')||'0',10);
    var suf = el.getAttribute('data-suffix')||'';
    var dur = 1100, start = null;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min((ts-start)/dur, 1);
      var eased = 1-Math.pow(1-p,3);
      el.textContent = (target*eased).toFixed(dec) + suf;
      if(p<1) requestAnimationFrame(step);
      else el.textContent = target.toFixed(dec) + suf;
    }
    requestAnimationFrame(step);
  }
  var counts = document.querySelectorAll('[data-count]');
  // Counters ship their final value in the HTML so non-JS crawlers read the real number.
  // Reset to zero here, at init, long before any of them scroll into view, so the
  // count-up still animates from 0 without the value visibly snapping back on screen.
  if(!reduce){ counts.forEach(function(el){ el.textContent = '0'; }); }
  if(reduce){ counts.forEach(function(el){ el.textContent = parseFloat(el.getAttribute('data-count')).toFixed(parseInt(el.getAttribute('data-dec')||'0',10)) + (el.getAttribute('data-suffix')||''); }); }
  else {
    var cio = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ animCount(en.target); cio.unobserve(en.target); } });
    }, {threshold:0.6});
    counts.forEach(function(el){ el.textContent = '0'; cio.observe(el); });
  }

  // hero load sequence
  requestAnimationFrame(function(){ requestAnimationFrame(function(){ document.body.classList.add('loaded'); }); });

  // mobile nav toggle
  var nt = document.querySelector('.navtoggle'), navEl = document.querySelector('nav');
  if(nt && navEl){
    nt.addEventListener('click', function(){
      var o = navEl.classList.toggle('open');
      nt.setAttribute('aria-expanded', o ? 'true' : 'false');
      nt.setAttribute('aria-label', o ? 'Close menu' : 'Open menu');
    });
    navEl.querySelectorAll('.links span').forEach(function(s){
      s.addEventListener('click', function(){ navEl.classList.remove('open'); nt.setAttribute('aria-expanded','false'); });
    });
  }

  // press marquee pause control
  var pb = document.querySelector('.pausebtn'), mt = document.querySelector('.mtrack');
  if(pb && mt){
    function setPaused(p){
      mt.classList.toggle('paused', p);
      pb.classList.toggle('paused', p);
      pb.querySelector('.ptxt').textContent = p ? 'Play motion' : 'Pause motion';
      pb.setAttribute('aria-pressed', p ? 'true' : 'false');
    }
    if(reduce){ setPaused(true); }
    pb.addEventListener('click', function(){ setPaused(!mt.classList.contains('paused')); });
  }

  // subtle hero parallax
  // Opt-out via data-noparallax. This writes an INLINE background-position, which beats
  // any stylesheet, so a page whose hero crop was solved against measured subject
  // positions must be able to refuse it. The weight loss hero does: bottom-drifting the
  // frame cuts the doctor's face off screen entirely at wider viewports.
  if(!reduce){
    var hero = document.querySelector('.imghero:not([data-noparallax])');
    if(hero){
      var ticking = false;
      window.addEventListener('scroll', function(){
        if(ticking) return; ticking = true;
        requestAnimationFrame(function(){
          var y = window.scrollY;
          if(y < 900){ hero.style.backgroundPosition = '52% ' + (30 + y*0.02) + '%'; }
          ticking = false;
        });
      }, {passive:true});
    }
  }
})();


/* ==========================================================================
   WHATSAPP PREFILL, and retirement of the visible (ref) token
   Added 5 Aug 2026

   THE PROBLEM
   The layout carries a pw_src script, ported from theme.liquid on 29 Jul 2026,
   which appends a code like (ref 7K0) to the prefilled message on any wa.me link.
   That code appears in the customer's own compose box before they press send, so
   a patient sees:

     Hi, I'd like to know more about the Core Health Test (ref 7K0)

   It only fires for people who arrived from an ad, so the prospects who cost the
   most are the only ones who see it. It reads as spam and depresses the metric
   that matters most on this channel: the share of people who actually press send.

   WHY THIS FILE AND NOT THE LAYOUT
   This runs at click time and overwrites the whole text parameter, so the token
   never survives regardless of what the layout does. Editing a 20KB Liquid layout
   to delete 45 lines is a bigger change with more ways to go wrong. The pw_src
   block can still be deleted properly later; this is correct either way, and if
   pw_src is removed this simply becomes the only prefill logic.

   ORDER OF EXECUTION
   pw_src is inline at the foot of body, so it registers its capture listener at
   parse time. This file is deferred, so it registers second and therefore runs
   second on the same node. Whatever pw_src wrote is overwritten here.

   THE PREFILL ITSELF
   Page aware, written as a person would write it. Agency data across large numbers
   of accounts is consistent that natural, product specific openers outperform
   generic marketing language, and that a question outperforms a statement because
   a question demands an answer. The weight loss opener asks about eligibility
   rather than price: same buying signal, opens on fit rather than cost, and keeps
   drug class language out of a message the patient sends.
   ========================================================================== */
(function(){
  if(window.__pv6WaPrefill){ return; }
  window.__pv6WaPrefill = 1;

  var MAP = [
    ['/pages/core-health-test',         "Hi, I have a question about the Core Health Test."],
    ['/pages/the-system',               "Hi, I have a question about the Core Health Test."],
    ['/pages/join-protocol',            "Hi, I have a question about joining PROTOCOL."],
    ['/pages/add-ons',                  "Hi, I have a question about the add on tests."],
    ['/pages/weight-loss',              "Hi, I'd like to know if I'm eligible for the weight loss programme."],
    ['/pages/eligibility',              "Hi, I'd like to know if I'm eligible for the weight loss programme."],
    ['/pages/weightloss',               "Hi, I'd like to know if I'm eligible for the weight loss programme."],
    ['/pages/multi-cancer-detection',   "Hi, I have a question about the cancer screening test."],
    ['/pages/std-test',                 "Hi, I'd like to book an STD test."],
    ['/pages/genetictest',              "Hi, I have a question about genetic testing."],
    ['/pages/testosterone-replacement', "Hi, I'd like to know more about testosterone therapy."]
  ];
  var FALLBACK = "Hi, I'd like to know more about PROTOCOL.";

  function prefill(){
    var p = (location.pathname || '').toLowerCase();
    for(var i = 0; i < MAP.length; i++){
      if(p.indexOf(MAP[i][0]) === 0){ return MAP[i][1]; }
    }
    return FALLBACK;
  }

  document.addEventListener('click', function(ev){
    try{
      var a = ev.target && ev.target.closest
        ? ev.target.closest('a[href*="wa.me"],a[href*="api.whatsapp.com"]')
        : null;
      if(!a){ return; }
      var u = new URL(a.href, location.origin);
      u.searchParams.set('text', prefill());
      a.href = u.toString();
    }catch(e){}
  }, true);
})();


/* ==========================================================================
   CLICK ID PERSISTENCE
   Added 5 Aug 2026

   THE PROBLEM
   Days to conversion runs 4 to 15 days. Ad platforms match a purchase back to a
   click using a click ID: gclid for Google, fbclid for Meta. Those IDs live in the
   URL for one page load and only survive if something stores them. Any session
   break, subdomain hop, redirect or browser clear loses them, and the order
   reports as direct. Roughly 70% of orders currently report that way.

   WHAT THIS DOES
   1. Captures gclid, fbclid and UTMs from the URL on any page.
   2. Stores them in first party cookies for 90 days.
   3. Backfills Meta's own _fbc cookie in the format Meta expects, if the pixel did
      not set it. This is what lifts Event Match Quality on OrderCompleted.
   4. Writes everything onto the Shopify cart as hidden attributes, so the IDs land
      on the order permanently and can be used for offline conversion upload when a
      sale closes days later on WhatsApp.

   Entirely silent. No customer facing UI, nothing to click, no friction.

   READING THE DATA
   Shopify admin, open any order, look under Additional details. Attributes are
   prefixed with an underscore so they are stored and exportable but never shown to
   the customer at checkout.

   NOTE ON LOAD ORDER
   Deferred, so it runs after the Meta pixel fires its first PageView. The _fbc
   backfill therefore lands from the second event onward, which covers
   OrderCompleted, the one that matters.
   ========================================================================== */
(function(){
  if(window.__pv6ClickPersist){ return; }
  window.__pv6ClickPersist = 1;

  var DAYS = 90;
  var PREFIX = 'pv6_';

  function setCookie(name, value, days){
    try{
      var d = new Date();
      d.setTime(d.getTime() + (days * 86400000));
      var h = location.hostname;
      var domain = (h.indexOf('www.') === 0) ? h.slice(4) : h;
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';expires=' + d.toUTCString() +
        ';path=/;domain=.' + domain + ';SameSite=Lax' +
        (location.protocol === 'https:' ? ';Secure' : '');
    }catch(e){}
  }

  function getCookie(name){
    try{
      var parts = document.cookie.split('; ');
      for(var i = 0; i < parts.length; i++){
        var eq = parts[i].indexOf('=');
        if(eq > -1 && parts[i].slice(0, eq) === name){
          return decodeURIComponent(parts[i].slice(eq + 1));
        }
      }
    }catch(e){}
    return '';
  }

  var params;
  try{ params = new URLSearchParams(location.search); }catch(e){ return; }

  var KEYS = ['gclid','fbclid','wbraid','gbraid','msclkid',
              'utm_source','utm_medium','utm_campaign','utm_content','utm_term'];

  KEYS.forEach(function(k){
    var v = params.get(k);
    if(v){ setCookie(PREFIX + k, v, DAYS); }
  });

  /* First touch landing page and referrer, written once and never overwritten, so
     a returning visitor keeps the page that originally brought them in. */
  if(!getCookie(PREFIX + 'landing')){
    setCookie(PREFIX + 'landing', location.pathname, DAYS);
    setCookie(PREFIX + 'referrer', (document.referrer || '').split('?')[0], DAYS);
    setCookie(PREFIX + 'first_seen', new Date().toISOString().slice(0,10), DAYS);
  }

  /* Meta reads a cookie named _fbc in the format fb.1.timestamp.fbclid. The pixel
     sets it on landing, but only if the pixel fired on that exact page load. If a
     redirect ate the parameter, or the pixel loaded late, _fbc never appears and
     every later event loses that match key. Rebuild it from the stored fbclid.
     Never overwrite a valid existing value. */
  var storedFbclid = getCookie(PREFIX + 'fbclid');
  if(storedFbclid && !getCookie('_fbc')){
    setCookie('_fbc', 'fb.1.' + Date.now() + '.' + storedFbclid, DAYS);
  }

  function payload(){
    var out = {};
    KEYS.concat(['landing','referrer','first_seen']).forEach(function(k){
      var v = getCookie(PREFIX + k);
      if(v){ out['_' + k] = v; }
    });
    var fbc = getCookie('_fbc');
    var fbp = getCookie('_fbp');
    if(fbc){ out['_fbc'] = fbc; }
    if(fbp){ out['_fbp'] = fbp; }
    return out;
  }

  var writing = false;
  function writeToCart(){
    if(writing){ return; }
    var attrs = payload();
    if(!Object.keys(attrs).length){ return; }
    writing = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify({ attributes: attrs })
    }).catch(function(){}).finally(function(){ writing = false; });
  }

  /* If the cart already has items on this page load, stamp it now. */
  fetch('/cart.js', {headers:{'Accept':'application/json'}})
    .then(function(r){ return r.json(); })
    .then(function(c){ if(c && c.item_count > 0){ writeToCart(); } })
    .catch(function(){});

  /* Re-stamp after any add to cart, including the PROTOCOL flow which posts to
     /cart/add.js directly. Wrapping fetch is the only reliable hook, since the
     flow does not emit a DOM event we can listen for. The original promise is
     returned untouched, so nothing downstream changes. */
  var origFetch = window.fetch;
  window.fetch = function(){
    var url = arguments[0];
    var href = (typeof url === 'string') ? url : (url && url.url) || '';
    var p = origFetch.apply(this, arguments);
    if(href.indexOf('/cart/add') > -1){
      p.then(function(){ setTimeout(writeToCart, 120); }).catch(function(){});
    }
    return p;
  };
})();
